export const FETCH_EVENTS = 'FETCH_EVENTS';
export const FETCH_LESSONS = 'FETCH_LESSONS';
export const CREATE_CUSTOM_DEMO = 'CREATE_CUSTOM_DEMO';
export const CHANGE_DATE = 'CHANGE_DATE';
export const CHANGE_CUSTOM_DEMO = 'CHANGE_CUSTOM_DEMO';
export const SELECT_DEMO_ITEM = 'SELECT_DEMO_ITEM';



// WEBPACK FOOTER //
// ./src/demo_new/action-types.js